/* Common Imports */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

/* Component Imports */

import { Typography, Paper } from '@material-ui/core';

/* Data Imports */

import AppConfig from '../../../AppConfig';

const useStyles = makeStyles((theme) => ({
  sectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    // width: '100%',
  },
  testimonialSubtitle: {
    color: '#000000',
    fontWeight: 600,
    fontSize: '1rem',
    lineHeight: '1.6875rem',
    padding: '0.5rem 0rem 0rem 0rem',
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.875rem',
      lineHeight: '1.25rem',
      letterSpacing: '0.016rem',
      width: '100%',
    },
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  size: {
    width: '350px',
    height: '40px',
    borderRadius: '0px',
    boxShadow:
      '0px 0px 0px rgb(0 0 0 / 10%), 0px 2px 5px rgb(0 0 0 / 12%), 0px 3px 5px rgb(0 0 0 / 0%)',
    [theme.breakpoints.down(theme.breakpoints.values.xs + 280)]: {
      width: '16rem',
    },
    [theme.breakpoints.up(theme.breakpoints.values.xs + 35)]: {
      width: '19rem',
      margin: '0px 0px 0px 20px',
    },
    [theme.breakpoints.up(theme.breakpoints.values.xs + 75)]: {
      width: '20rem',
      margin: '0px 0px 0px 0px',
    },
    [theme.breakpoints.up(theme.breakpoints.values.xs + 131)]: {
      width: '22rem',
      margin: '0px 0px 0px 0px',
    },
    [theme.breakpoints.up(theme.breakpoints.values.xs + 250)]: {
      width: '22rem',
      margin: '0px 0px 0px 0px',
    },
    [theme.breakpoints.up(theme.breakpoints.values.sm + 168)]: {
      width: '21rem',
      margin: '0px 0px 0px 0px',
    },
    [theme.breakpoints.up(theme.breakpoints.values.md + 60)]: {
      width: '24rem',
      margin: '0px 0px 0px 0px',
    },
  },
  testimonialIcon: {
    [theme.breakpoints.down(theme.breakpoints.values.xs + 280)]: {
      width: '16rem',
      height: '16rem',
    },
    [theme.breakpoints.up(theme.breakpoints.values.xs + 35)]: {
      width: '19rem',
      height: '21rem',
      margin: '0px 0px 0px 16px',
    },
    [theme.breakpoints.up(theme.breakpoints.values.xs + 75)]: {
      width: '20rem',
      height: '21rem',
      margin: '0px 0px 0px 0px',
    },
    [theme.breakpoints.up(theme.breakpoints.values.xs + 131)]: {
      width: '22rem',
      height: '21rem',
      margin: '0px 0px 0px 0px',
    },
    [theme.breakpoints.up(theme.breakpoints.values.xs + 250)]: {
      width: '22rem',
      height: '21rem',
      margin: '0px 0px 0px 0px',
    },
    [theme.breakpoints.up(theme.breakpoints.values.sm + 168)]: {
      width: '21rem',
      height: '22rem',
      margin: '0px 0px 0px 0px',
    },
    [theme.breakpoints.up(theme.breakpoints.values.md + 60)]: {
      width: '24rem',
      height: '22rem',
      margin: '0px 0px 0px 0px',
    },
  },
}));

const Testimonial = (props) => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <div className={classes.sectionContainer}>
        <img
          src={
            props.thumbnailLink
              ? props.thumbnailLink
              : '/images/icons/testimonials/saranya-and-govindh.webp'
          }
          alt={AppConfig.imageAltText}
          width={350}
          height={350}
          loading="lazy"
          referrerPolicy="no-referrer"
          longdesc="https://advisory.beegru.com"
          className={classes.testimonialIcon}
        />
        <Paper className={classes.size} elevation={1}>
          <Typography
            variant="body2"
            component="span"
            className={classes.testimonialSubtitle}
          >
            {props.subTitle ? props.subTitle : 'PEANUT'}
          </Typography>
        </Paper>
      </div>
    </React.Fragment>
  );
};

export default Testimonial;
